import React from 'react';
import { BookOpenIcon, ShieldCheckIcon } from 'lucide-react';
import { mockupUrl, offerAnchor } from '../data/content';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function Hero() {
  return <section className="bg-navy px-4 pb-14 pt-10 md:pb-16 md:pt-14" data-id="element-93" data-mp="9lbfqzxtf9d2">
      <div className="mx-auto max-w-4xl text-center" data-id="element-94" data-mp="4mi4zf9wxwgl">
        <p className="font-display text-[11px] font-extrabold uppercase tracking-[.3em] text-brand-light md:text-xs" data-id="element-95" data-mp="4jvv38zjv4v7">
          Bright Digital Hub
        </p>
        <h1 className="mx-auto mt-4 max-w-3xl font-display font-black uppercase leading-tight tracking-tight text-white" data-id="element-96" data-mp="xbpd95z660f1">
          <span className="block text-sm md:text-lg" data-id="element-97" data-mp="s9gic42qkoaa">The complete ready-to-use exercise system for</span>
          <span className="mt-2 block text-2xl text-brand-light sm:text-3xl md:text-[2.75rem] md:leading-[1.05]" data-id="element-98" data-mp="neawt6d8xbmq">
            Injury Rehabilitation & Progressive Strengthening
          </span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base" data-id="element-99" data-mp="384jq2q4e53op">
          Have one organized resource for mobility, activation, strengthening, stability and progressive return to
          training.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-sm leading-relaxed text-white/70" data-id="element-100" data-mp="39b4fyxmj3o1c">
          Access practical exercises for the shoulder, knee, ankle, elbow, wrist, hand, spine and hip, with sets, reps,
          rest periods, regressions and progressions already included.
        </p>
        <p className="mt-5 font-display text-xs font-black uppercase tracking-wider text-white md:text-sm" data-id="element-101" data-mp="3599jq7jgg0uf">
          Less time organizing. <span className="text-brand-light" data-id="element-102" data-mp="2ql68ojqk1yyr">More clarity in every session.</span>
        </p>

        <OfferLink className="mx-auto my-7 max-w-[300px] sm:max-w-[400px]" label="See the Complete Injury Rehabilitation Bundle offer" data-id="element-103" data-mp="2vjpywwc6lwwx">
          <img src={mockupUrl} alt="Complete Injury Rehabilitation Bundle: 5 complete volumes and 5 practical bonuses" className="w-full rounded-2xl bg-white object-contain p-3 shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-104" data-mp="2hl9q8zurdwc5" />
        </OfferLink>

        <Button href={offerAnchor} size="lg" subtext="Get instant digital access today" data-id="element-105" data-mp="ibyowaipsy14">
          Yes! I want the complete system
        </Button>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-bold uppercase tracking-wide text-white/80" data-id="element-106" data-mp="deq7wd9az01g">
          <li className="flex items-center gap-1.5" data-id="element-107" data-mp="161t1cqz4gkku">
            <ShieldCheckIcon className="h-4 w-4 text-brand-light" aria-hidden="true" data-id="element-108" data-mp="16342sk53hg8s" /> 7-Day Guarantee
          </li>
          <li className="flex items-center gap-1.5" data-id="element-109" data-mp="110wqftgcry5x">
            <BookOpenIcon className="h-4 w-4 text-brand-light" aria-hidden="true" data-id="element-110" data-mp="x1w96fdix3l1" /> 5 Complete Volumes + 5 Practical Bonuses
          </li>
        </ul>
      </div>
    </section>;
}